import Swiper, {Navigation, Pagination} from 'swiper'

export default {
  init() {
    if ($('body').hasClass('page-template-template-home-v2')) {
      return
    }

    Swiper.use([Navigation, Pagination]);

    $('.swiper').each(function() {
      new Swiper($(this).get(0), {
        slidesPerView: 1,
        speed: 400,
        pagination: {
          el: $(this).find('.swiper-pagination').get(0),
          type: 'bullets',
        },
        navigation: {
          nextEl: $(this).find('.swiper-button-next').get(0),
          prevEl: $(this).find('.swiper-button-prev').get(0),
        },
        loop: true,
      })
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-home-v1.js